export type { ISelectedCalendarDate } from '@core/interface';
